var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBkpPhase3Chapter2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "FOND",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1383.939,
    height: 1037.954,
    viewBox: "0 0 1383.939 1037.954",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-chapter2-bkg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "FOND_FIXE",
    "data-name": "FOND FIXE",
    d: "M0,0H1383.939V1037.954H0Z",
    fill: "#9870b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-chapter2-bkg",
    x1: 0.492,
    y1: -0.124,
    x2: 0.519,
    y2: 0.884,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dce7d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6b39a"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "FOND_FIXE-2",
    "data-name": "FOND FIXE",
    d: "M0,0H1383.939V1037.954H0Z",
    transform: "translate(0 0)",
    fill: "#9870b6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_55",
    "data-name": "Mask Group 55",
    clipPath: "url(#clip-path-chapter2-bkg)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "FOND-2",
    "data-name": "FOND",
    d: "M1383.939,1037.954H0V0H1383.939Z",
    fill: "url(#linear-gradient-chapter2-bkg)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBkpPhase3Chapter2);
export default __webpack_public_path__ + "static/media/bkp-phase3-chapter2.6552345d.svg";
export { ForwardRef as ReactComponent };